import React from 'react';
import { Image, Container, Heading, Box, Text, Grid, Button, Flex } from '@chakra-ui/react';
import DescriptionModal from '../DescriptionModal/DescriptionModal';
import questionIcon from '../../assets/images/question.svg';

const ProductLayout = ({
    productData,
    heading,
    paddingTop,
    paddingBottom,
    imageWidth,
    selectedServices,
    handleClick,
    handleButtonClick,
    selectedServicesTypes,
    selectedImage,
    selectedDescription,
    selectedButtonServiceID,
    minH,
    minTextHeight,
    maxH,
    isPackageSection
}) => {
    return (
        <Container maxW="1200px" py={2}>
            <Heading variant="h3" mb={6} textAlign="center">{heading}</Heading>

            {isPackageSection ? (
                <Grid
                    templateColumns="repeat(auto-fill, 290px)"
                    justifyContent="center"
                    gap="20px"
                    rowGap="30px"
                >
                    {productData.map((data, index) => (
                        <Box
                            key={index}
                            onClick={() => handleClick(data.id)}
                            background={selectedServices?.includes(data?.id) ? "#E7FFD5" : 'initial'}
                            border="1px"
                            borderColor={selectedServices?.includes(data?.id) ? 'green.400' : 'gray.100'}
                            borderRadius="10px"
                            overflow="hidden"
                            transition=".5s"
                            _hover={{ boxShadow: { base: 'none', md: 'md' } }}
                            w="290px"
                            h="148px"
                            position="relative"
                        >
                            <Box position="absolute" top="6px" right="6px" zIndex="2">
                                <DescriptionModal
                                    description={data.button?.find(e => e.id === selectedServicesTypes?.[data?.id])?.description ?? data.description}
                                    heading={`${data.heading} (package)`}
                                    isBundle={true}
                                />
                            </Box>

                            <Flex flexDirection="column" justifyContent="center" height="100%" alignItems="center">
                                <Box pt={paddingTop} pb={paddingBottom}>
                                    <Image src={selectedButtonServiceID === data.id ? selectedImage : data.image} alt="services image" style={{ margin: 'auto' }} pb={2} width={imageWidth ?? 'auto'} />
                                    <Text variant="custom-para" textAlign="center" minH={minTextHeight ?? "max-content"}>{data.heading}</Text>
                                </Box>
                            </Flex>
                        </Box>
                    ))}
                </Grid>
            ) : (
                <Flex justifyContent="center" flexWrap="wrap" gap={3}>
                    {productData.map((data, index) => (
                        <Box
                            key={index}
                            onClick={() => handleClick(data.id)}
                            background={selectedServices?.includes(data?.id) ? 'green.900' : 'initial'}
                            border="1px"
                            borderColor={selectedServices?.includes(data?.id) ? 'green.400' : 'gray.100'}
                            borderRadius="10px"
                            marginY={{base: '5px', md: '2px'}}
                            overflow="hidden"
                            transition=".5s"
                            _hover={{ boxShadow: { base: 'none', md: 'md' } }}
                            width={{ lg: '220px', md: '220px', base: '48%' }}
                            height="110px"
                            position="relative"
                        >
                            <Box position="absolute" top="6px" right="6px" zIndex="2">
                                <DescriptionModal
                                    description={data.button?.find(e => e.id === selectedServicesTypes?.[data?.id])?.description ?? data.description}
                                    heading={data.heading}
                                />
                            </Box>

                            <Flex flexDirection="column" justifyContent={data.button ? 'space-between' : 'center'} height="100%" alignItems="center">
                                <Box pt={paddingTop} pb={paddingBottom}>
                                <Image
                                    src={
                                        data.button?.find(e => e.id === selectedServicesTypes?.[data?.id])?.image
                                        ?? data.image
                                    }
                                    alt="services image"
                                    style={{ margin: 'auto' }}
                                    pb={2}
                                    width={imageWidth ?? 'auto'}
                                    />
                                    <Text variant="custom-para" textAlign="center" fontSize={{ base: '14px', md: '16px' }} minH={minTextHeight ?? "max-content"}>{data.heading}</Text>
                                </Box>

                                <Flex justifyContent="space-between" width="100%" borderColor="#BEEF8E" borderTopWidth={data.button ? '2px' : '0'}>
                                    {data.button && data.button.map((x, i) => (
                                        <Button
                                            key={i}
                                            variant="solid-btn"
                                            background={selectedServicesTypes[data?.id] === x.id ? 'green.900' : '#fff'}
                                            onClick={(e) => handleButtonClick(e, data?.id, i, x)}
                                            fontSize={{ base: '10px', md: '12px' }}
                                        >
                                            {x?.heading ?? x}
                                        </Button>
                                    ))}
                                </Flex>
                            </Flex>
                        </Box>
                    ))}
                </Flex>
            )}
        </Container>
    );
};

export default ProductLayout;
